import { j as b } from "../../_virtual/jsx-runtime.js";
import { c as d } from "../../_virtual/compiler-runtime.js";
import { tv as h } from "../../bundled_deps/.pnpm/tailwind-variants@0.3.1_tailwindcss@3.4.17/bundled_deps/tailwind-variants/dist/index.js";
import { cn as f } from "../../utils/cn.js";
import { Root as v } from "../../bundled_deps/.pnpm/@radix-ui_react-slot@1.2.4_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-slot/dist/index.js";
const g = h({
  base: ["group rounded-full transition-colors", "inline-flex items-center justify-center", "text-default font-semibold leading-4  select-none whitespace-nowrap", "outline outline-transparent", "disabled:cursor-not-allowed disabled:bg-neutral-container disabled:text-disabled disabled:outline-none", "focus:outline-2 focus:-outline-offset-2 focus:outline-neutral-border-emphasis", "active:outline-1 active:-outline-offset-1", "focus-visible:outline-2 focus-visible:outline-accent-border focus-visible:outline-offset-2", "active:focus-visible:outline-2 active:focus-visible:outline-accent-border-emphasis active:focus-visible:outline-offset-1"],
  variants: {
    variant: {
      primary: ["bg-neutral-fill text-on-neutral hover:bg-neutral-fill-emphasis", "focus:bg-neutral-fill-emphasis focus:outline-neutral-border-emphasis", "active:bg-neutral-fill-emphasis active:outline-neutral-border-emphasis"],
      secondary: ["bg-neutral-container text-default hover:bg-neutral-container-emphasis", "focus:bg-neutral-border-emphasis focus:border-neutral-border-emphasis", "active:bg-neutral-border-emphasis active:border-neutral-border-emphasis"],
      tertiary: ["text-default hover:bg-neutral-container-emphasis", "focus:bg-neutral-container-emphasis focus:outline-neutral-border-emphasis", "active:bg-neutral-container-emphasis active:outline-neutral-border-emphasis"],
      "primary-destructive": ["bg-error-fill text-on-error hover:bg-error-fill-emphasis", "focus:bg-error-fill-emphasis focus:outline-error-border-emphasis", "active:bg-error-fill-emphasis active:outline-error-border-emphasis"],
      "secondary-destructive": ["bg-error-container text-default hover:bg-error-container-emphasis", "active:bg-error-container-emphasis active:outline-error-border-emphasis", "focus:bg-error-container-emphasis focus:outline-error-border-emphasis"],
      "primary-live": ["bg-success-fill text-on-success hover:bg-success-fill-emphasis", "active:bg-success-fill-emphasis active:outline-success-border-emphasis", "focus:bg-success-fill-emphasis focus:outline-success-border-emphasis"],
      "secondary-live": ["bg-success-container text-default hover:bg-success-container-emphasis", "focus:bg-success-container-emphasis focus:outline-success-border-emphasis", "active:bg-success-container-emphasis active:outline-success-border-emphasis"],
      "primary-paywall": ["bg-paywall-fill text-on-paywall hover:bg-paywall-fill-emphasis", "focus:bg-paywall-fill-emphasis focus:outline-paywall-border-emphasis", "active:bg-paywall-fill-emphasis active:outline-paywall-border-emphasis"],
      "secondary-paywall": ["bg-paywall-container text-default hover:bg-paywall-container-emphasis", "active:bg-paywall-container-emphasis active:outline-paywall-border-emphasis", "focus:bg-paywall-container-emphasis focus:outline-paywall-border-emphasis"],
      "secondary-outline": ["bg-base-module text-default outline-1 outline-neutral-border -outline-offset-1", "hover:bg-neutral-container-emphasis", "focus:bg-neutral-container-emphasis focus:outline-neutral-border-emphasis", "active:bg-neutral-container-emphasis active:outline-neutral-border-emphasis"],
      link: "text-default hover:text-link active:text-link active:outline-0"
    },
    size: {
      small: "text-support px-2 py-1",
      medium: "px-3 py-2",
      large: "px-4 py-3"
    },
    iconOnly: {
      true: "",
      false: "gap-1"
    }
  },
  compoundVariants: [{
    size: "small",
    iconOnly: !0,
    class: "p-1"
  }, {
    size: "medium",
    iconOnly: !0,
    class: "p-2"
  }, {
    size: "large",
    iconOnly: !0,
    class: "p-3"
  }, {
    size: "large",
    iconOnly: !1,
    class: "gap-2"
  }],
  defaultVariants: {
    variant: "secondary",
    size: "medium"
  }
}), y = (o) => {
  const e = d.c(16);
  let s, t, a, i, r, n;
  e[0] !== o ? ({
    className: s,
    variant: i,
    size: r,
    iconOnly: t,
    asChild: n,
    ...a
  } = o, e[0] = o, e[1] = s, e[2] = t, e[3] = a, e[4] = i, e[5] = r, e[6] = n) : (s = e[1], t = e[2], a = e[3], i = e[4], r = e[5], n = e[6]);
  const u = i === void 0 ? "secondary" : i, p = r === void 0 ? "medium" : r, m = (n === void 0 ? !1 : n) ? v : "button";
  let l;
  e[7] !== s || e[8] !== t || e[9] !== p || e[10] !== u ? (l = f(g({
    variant: u,
    size: p,
    iconOnly: t
  }), s), e[7] = s, e[8] = t, e[9] = p, e[10] = u, e[11] = l) : l = e[11];
  let c;
  return e[12] !== m || e[13] !== a || e[14] !== l ? (c = /* @__PURE__ */ b.jsx(m, { type: "button", className: l, ...a }), e[12] = m, e[13] = a, e[14] = l, e[15] = c) : c = e[15], c;
};
y.displayName = "Button";
function x(o) {
  const e = d.c(10);
  let s, t, a;
  e[0] !== o ? ({
    children: s,
    className: t,
    ...a
  } = o, e[0] = o, e[1] = s, e[2] = t, e[3] = a) : (s = e[1], t = e[2], a = e[3]);
  let i;
  e[4] !== t ? (i = f("ml-1 inline-flex min-w-4 items-center justify-center rounded bg-neutral-container px-1 text-caption font-normal leading-4 text-default outline-1 outline-neutral-border group-disabled:bg-transparent group-disabled:text-disabled group-disabled:outline-neutral-border", t), e[4] = t, e[5] = i) : i = e[5];
  let r;
  return e[6] !== s || e[7] !== a || e[8] !== i ? (r = /* @__PURE__ */ b.jsx("span", { className: i, ...a, children: s }), e[6] = s, e[7] = a, e[8] = i, e[9] = r) : r = e[9], r;
}
x.displayName = "ButtonShortcut";
export {
  y as Button,
  x as ButtonShortcut,
  g as buttonVariants
};
